import { render, staticRenderFns } from "./TextPrompt.vue?vue&type=template&id=842572ae&scoped=true&"
import script from "./TextPrompt.vue?vue&type=script&lang=js&"
export * from "./TextPrompt.vue?vue&type=script&lang=js&"
import style0 from "./TextPrompt.vue?vue&type=style&index=0&id=842572ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842572ae",
  null
  
)

export default component.exports